import React, {useEffect, useRef, useState} from "react";
import Dependencies from "../../../../../utilities/Dependencies";
import Environment from "../../../../../services/interfaces/Environment";
import PageActions from "../../../../base/PageActions";
import ContentBox from "../../../../../components/content-box/ContentBox";
import Modal from "../../../../../components/modal/Modal";
import GalleryItem from "../../../../../model/GalleryItem";
import '../../../../styles/Common.scss';
import '../GalleryPage.scss';

interface CommissionGalleryPageProps {
    dependencies: Dependencies,
    env: Environment
}

const CommissionGalleryPage = (props: CommissionGalleryPageProps) => {

    const page: PageActions = new PageActions({
        dependencies: props.dependencies,
        env: props.env,
        title: `Commission Gallery - Chase the Fox`,
        description: `Art done by Chase as commission work, a portfolio of sorts for everyone to view!`,
        keywords: ["commission", "art", "portfolio", "commission work", "commissioned"],
        imgSrc: `chase/assets/chase_artist.png`,
        url: `galleries/commissions`
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const resultModalItem = useRef<GalleryItem | undefined>();

    const [hasFetchedResult, setFetchedResult] = useState<boolean>(false);
    const resultItems = useRef<GalleryItem[]>([]);

    useEffect(() => {
        page.http().getAllGalleryItems("commissions")
            .then(response => {
                if (!response || Object.keys(response).length === 0) {
                    resultItems.current = [];
                } else {
                    resultItems.current = response;
                }
            })
            .finally(() => setFetchedResult(true));
    }, []);

    const openFullArt = (id: string) => {
        page.http().getGalleryItem("commissions", id)
            .then(response => {
                if (!response || Object.keys(response).length === 0) {
                    resultModalItem.current = undefined;
                } else {
                    resultModalItem.current = response;
                    setModalIsOpen(true);
                }
            })
            .catch(() => setModalIsOpen(false))
            .finally(() => setFetchedResult(true));
    }

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen}
                   onClose={() => setModalIsOpen(false)}>
                <div className="gallery-modal-view">
                    {resultModalItem.current && <>
                        <div className="gallery-modal-header">
                            <h2 className="center headline">{resultModalItem.current.title}</h2>
                            <p>{resultModalItem.current.description}</p>
                        </div>
                        <img src={page.image().getCdnImageSrc(resultModalItem.current.location)}
                             alt={resultModalItem.current.title}
                             title={resultModalItem.current.title}/>
                    </>}
                </div>
            </Modal>
            <ContentBox header="Commissions Done by Chase">
                <p className="center">
                    This is a portfolio of my past work! If you'd like to get a commission from me, then you can check
                    out my price list, offers, and current commission form <a
                        href="/commissions"
                        target="_blank"
                        rel="noopener noreferrer">on this page!</a>
                </p>
                <div className="gallery-item-list">
                    <ul>
                        {hasFetchedResult && resultItems.current.map((item, index) => <li key={`commission-gallery-${index}`}>
                            <a onClick={() => openFullArt(item.id || '')}>
                                <img src={page.image().getCdnImageSrc(item.location, 'thumbnail')}
                                     alt={`Commission Gallery Item ${index+1}`}
                                     title="Click on this thumbnail to see the full art!"/>
                            </a>
                        </li>)}
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default CommissionGalleryPage;